export const environment = {
  production: true,
  buildId: '3081456873820301',
  configFile: 'config.json',
};
